import React, { useEffect, useState } from "react";
import Card from "components/common/Card/Card";
import { connect } from "react-redux";
import { useParams, useLocation } from "react-router";
import styles from "./ProviderEnrollmentDashboard.scss";
import ProviderBase from "components/layout/ProviderBase";
import { getProviderProgramsAction } from "actions/ProviderActions";
import OfferEnrollment from "./OfferEnrollment";
import { PermissionTypes, userHasPermission } from "utils/permissions/rolesPermissions";
import * as UserPermissions from "constants/UserPermissions";
import SpinnerTakeover from "components/common/SpinnerTakeover";
import AccessDeniedPage from "components/clinic/pages/AccessDeniedPage";


function ProviderEnrollmentDashboard(props) {
    const {
        nodeId,
        isLoading,
        getPrograms,
        programs,
        canViewProviderPrograms
    } = props;

    const params = useParams();
    const location = useLocation();
    const providerId = Number(params.providerId);

    const [programServices, setProgramServices] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
        setShowSpinner(true);
        getPrograms(nodeId);
        setShowSpinner(false);
    }, [nodeId]);

    useEffect(() => {
        if (programs.length > 0) {

            const allServices = programs
                .flatMap(entry => entry.programs || [])
                .flatMap(program => program.programServices || []);
            setProgramServices(allServices);
        }
    }, [programs]);

    const handleActionButton = (item) => {
        setSelectedProgram(item);
    };

    const handleBackToDashboard = () => {
        setSelectedProgram(null);
        getPrograms(nodeId);
    };

    const getCardProps = (item) => {
        if (item.isFinalized) {
            return {
                actionButton: "View Details",
                buttonType: "secondary",
                action: () => handleActionButton(item),
                icon: <i className="fa fa-check"></i>,
                statusMessage: "Enrollment Complete"
            };
        } else {
            return {
                actionButton: "Enroll Now",
                buttonType: "primary",
                action: () => handleActionButton(item),
                icon: null,
                statusMessage: null
            };
        }
    };


    return canViewProviderPrograms ? (
        <ProviderBase location={location} providerId={providerId} nodeId={nodeId}>
            <div className={styles.dashboardContainer}>
                {!selectedProgram ? (
                    <>
                        <h1 className={styles.dashboardHeader}>Offer Enrollment</h1>
                        <div className={styles.cardContainer}>
                            {programServices.map((item, index) => {
                                const { actionButton, buttonType, action, icon, statusMessage } = getCardProps(item);
                                return (
                                    <Card
                                        key={item.programServiceId || index}
                                        title={item.programServiceName}
                                        statusMessage={statusMessage}
                                        statusIcon={icon}
                                        actionButton={actionButton}
                                        buttonType={buttonType}
                                        action={action}
                                    />
                                );
                            })}
                        </div>
                    </>
                ) : (
                    <div>
                        <div className={styles.backButton} onClick={handleBackToDashboard}>
                            <i className="fa fa-arrow-left"></i> 
                            <div>Back to all offers</div>
                        </div>
                        <OfferEnrollment
                            programService={selectedProgram}
                            nodeId={nodeId}
                        />
                    </div>
                )}
            </div>

            <SpinnerTakeover show={showSpinner || isLoading} />
        </ProviderBase>
    ) : (
        <AccessDeniedPage />
    );
}

export default connect(
    (state, ownProps) => {
        const userProfile = state.user.userProfile;
        const currentOrgNode = state.entities.orgNode?.current;
        const params = ownProps?.match?.params || {};
        const nodeId = Number(params?.nodeId) || null;
        const canViewProviderPrograms = userHasPermission(PermissionTypes.VIEW, UserPermissions.PROVIDER_OFFER_ENROLLMENT, userProfile);
        return {
            nodeId,
            isLoading: state.entities.providerPrograms?.isLoading || false,
            programs: state.entities.providerPrograms?.programs || [],
            userProfile,
            currentOrgNode,
            canViewProviderPrograms
        };
    }, (dispatch) => ({
        getPrograms: (nodeId) =>
            dispatch(getProviderProgramsAction(nodeId)),
    }),
    )(ProviderEnrollmentDashboard);